import settings from '../settings'

const getClient = () => {
  if (settings.auth.magic) {
    try {
      const { MagicClient } = require('@chordcommerce/chord-magic')
      return new MagicClient({ apiKey: settings.auth.magic.apiKey })
    } catch (error) {
      console.error(error)
    }
  } else if (settings.auth.stytch) {
    try {
      const { StytchClient } = require('@chordcommerce/chord-stytch')
      return new StytchClient(settings.auth.stytch)
    } catch (error) {
      console.error(error)
    }
  }
}

const client = getClient()
export default client
